module.exports = __webpack_public_path__ + "img/14.2-gallery.9dd30334.jpg";